import { apiClient, buildQuery } from '~/api/client'
import type {
    AdminSession,
    AdminSessionDetail,
    MessageDetail,
    TranscriptMessage,
} from '~/api/types'

// 대화 세션 읽기 API. 상담 "대화로그" 탭에서 세션 목록·메시지를 소비한다.

export interface ListSessionsParams {
    profile?: string
    status?: string
    q?: string
    dateFrom?: string
    dateTo?: string
    limit?: number
    offset?: number
}

/** GET /admin/api/sessions — 세션 목록(필터·페이지네이션). */
export function listSessions(params: ListSessionsParams = {}) {
    const query = buildQuery({
        profile: params.profile,
        status: params.status,
        q: params.q,
        date_from: params.dateFrom,
        date_to: params.dateTo,
        limit: params.limit,
        offset: params.offset,
    })
    return apiClient.get<AdminSession[]>(`/sessions${query}`)
}

/** GET /admin/api/sessions/{id} — 세션 상세(사용자·제목·집계 지표). */
export function getSession(id: string) {
    return apiClient.get<AdminSessionDetail>(`/sessions/${id}`)
}

/** GET /admin/api/sessions/{id}/messages — 세션 메시지(시간순). */
export function getSessionMessages(id: string) {
    return apiClient.get<TranscriptMessage[]>(`/sessions/${id}/messages`)
}

/** GET /admin/api/sessions/messages/{id} — 단일 메시지 + 소속 세션(피드백 드릴다운). */
export function getMessage(id: string) {
    return apiClient.get<MessageDetail>(`/sessions/messages/${id}`)
}
